import { PromiseCompletionSource } from "scene-manager";
import { BaseLoseSceneView } from "../BaseLoseSceneView";
import { LoseSceneResourcesPackage } from "../../resources/LoseSceneResourcesPackage";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { LoseController } from "../../controller/LoseController";
import { Emitter, upgradeConfig } from "@pixi/particle-emitter";
import { Container, IDestroyOptions } from "@pixi/display";
import { Spine } from "pixi-spine";
import { Localization } from "../../../common/Localization";
import { FitText } from "../../../common/components/FitText";
import { AudioManager } from "../../../../audio/AudioManager";
import { GreenTextStyle, YellowTextStyle } from "../../resources/LoseTextStyles";

export class NewBestScoreLoseSceneView extends BaseLoseSceneView {
    private particles: Emitter;
    private particlesContainer: Container;
    private circleAnimation: Spine;
    private gameOver: FitText;
    private scoreText: FitText;
    private playerScore: FitText;

    public constructor(
        canvasScaler: ICanvasScaler,
        loseSceneResourcesPackage: LoseSceneResourcesPackage,
        loseController: LoseController,
        localization: Localization,
        audioManager: AudioManager,
        operationControls: PromiseCompletionSource<void>,
    ) {
        const backgroundTexture = window.maxTextureSize <= 4096
            ? loseSceneResourcesPackage.assets_lose_background_green_mobile_png :
            loseSceneResourcesPackage.assets_lose_background_green_png;
        super(canvasScaler,
            backgroundTexture,
            loseSceneResourcesPackage,
            loseController,
            localization,
            audioManager,
            operationControls
        );
    }

    protected build(): void {
        super.build();
        const config = upgradeConfig(this.loseSceneResourcesPackage.assets_lose_effects_particles_emitter_json as any,
            [
                this.loseSceneResourcesPackage.assets_lose_effects_particles_dot_1_png,
                this.loseSceneResourcesPackage.assets_lose_effects_particles_dot_2_png,
                this.loseSceneResourcesPackage.assets_lose_effects_particles_dot_3_png
            ]);
        this.particlesContainer = new Container();
        this.addChild(this.particlesContainer);
        this.particles = new Emitter(this.particlesContainer, config);
        this.particles.autoUpdate = true;

        this.circleAnimation = new Spine((this.loseSceneResourcesPackage.assets_lose_effects_win_glow_win_glow_json as any).spineData);
        this.circleAnimation.state.setAnimation(0, "win_glow", true);
        this.addChild(this.circleAnimation);

        this.gameOver = new FitText(this.localization.getText("game_over"), new GreenTextStyle(105), 690, 195);
        this.addChild(this.gameOver);
        this.gameOver.anchor.set(0.5);

        this.scoreText = new FitText(this.localization.getText("best_moves"), new YellowTextStyle(65, "green"), 260, 85);
        this.addChild(this.scoreText);
        this.scoreText.anchor.set(0.5);

        this.playerScore = new FitText(this.loseController.getPlayerScore().toString(), new YellowTextStyle(150, "green"), 650, 220);
        this.addChild(this.playerScore);
        this.playerScore.anchor.set(0.5);

        this.restartText.updateBaseStyle(new GreenTextStyle(100));
    }

    protected layout(): void {
        super.layout();
        const referenceWidth = this.canvasScaler.referenceWidth;
        this.gameOver.position.set(referenceWidth * 0.5, 327 + (this.gameOver.height * 0.5));
        this.scoreText.position.set(referenceWidth * 0.5, 618 + (this.scoreText.height * 0.5));
        this.playerScore.position.set(referenceWidth * 0.5, 701 + (this.playerScore.height * 0.5));
        this.particlesContainer.position.set(referenceWidth * 0.5, this.playerScore.position.y);
        this.circleAnimation.position.set(referenceWidth * 0.5, this.playerScore.position.y);
    }

    public destroy(options?: IDestroyOptions | boolean): void {
        this.particles.destroy();
        super.destroy(options);
    }
}